// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__stjU6","title":"AfterFrontImage_title__2m28m"};